import React, { useEffect, useState } from "react";
import {
  getAdminNotification,
  getStudents,
} from "../../../services/admin.services"; // Adjust path
import { getChatNotifications } from "../../../services/admin.services"; // Correct import path
import { useSelector } from "react-redux";

// Reusable Notification Table Component
const NotificationTable = ({ title, data }) => {
  return (
    <div className="bg-blue-50 p-1 rounded-md border-solid border-2 border-gray-600 mb-6">
      {/* Header */}
      <div className="pb-4 p-4">
        <h2 className="text-lg font-semibold text-gray-700">{title}</h2>
      </div>

      {/* Table Container with Fixed Height */}
      <div className="overflow-y-auto max-h-60">
        <table className="min-w-full bg-white rounded-lg shadow-md">
          <thead>
            <tr className="bg-blue-200 text-gray-600 text-sm leading-normal">
              {title === "CRM Notifications" ? (
                <>
                  <th className="py-3 px-6 text-left">Sr.No</th>
                  <th className="py-3 px-6 text-left">Notification</th>
                </>
              ) : (
                <>
                  <th className="py-3 px-6 text-left">Sr.No</th>
                  <th className="py-3 px-6 text-left">Student Name</th>
                  <th className="py-3 px-6 text-left">Email ID</th>
                  <th className="py-3 px-6 text-left">Mobile Number</th>
                  {/* <th className="py-3 px-6 text-left">Notifications</th> */}
                  <th className="py-3 px-6 text-left">Message</th>
                </>
              )}
            </tr>
          </thead>

          {/* Scrollable Table Body */}
          <tbody className="overflow-y-auto max-h-60">
            {data.length > 0 ? (
              data.map((item, index) => (
                <tr key={index} className="text-gray-700 text-sm border-b">
                  <td className="py-3 px-6">{index + 1}</td>
                  {title === "CRM Notifications" ? (
                    <td className="py-3 px-6">
                      {item.message_content || "N/A"}
                    </td>
                  ) : (
                    <>
                      <td className="py-3 px-6">
                        {item.student_name || "N/A"}
                      </td>
                      <td className="py-3 px-6">{item.email_id || "N/A"}</td>
                      <td className="py-3 px-6">
                        {item.mobile_number || "N/A"}
                      </td>
                      {/* <td className="py-3 px-6">
                        {item.notification_text || "N/A"}
                      </td> */}
                      <td className="py-3 px-6">
                        {item.message_content || "N/A"}
                      </td>
                    </>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={title === "CRM Notifications" ? "2" : "6"}
                  className="text-center py-4 text-gray-500"
                >
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// Main Component
const NotificationsPage = () => {
  const user = useSelector((state) => state.user.userDetails);
  const [notifications, setNotifications] = useState([]);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const students = useSelector((state) => state.dashboard.students); // Fetch students from Redux

  // Fetch CRM Notifications
  // const fetchCRMNotifications = async () => {
  //   if (!user || !user.admin_id) {
  //     console.warn("Admin ID not available, skipping API call.");
  //     return;
  //   }

  //   try {
  //     const res = await getAdminNotification(user.admin_id);
  //     "CRM Notifications Response:", res);

  //     const formattedNotifications =
  //       res?.data?.notifications?.map((item, index) => ({
  //         message_content: item.message || "N/A",
  //       })) || [];

  //     setNotifications(formattedNotifications);
  //   } catch (err) {
  //     console.error("Error fetching CRM notifications:", err);
  //     setError("Failed to fetch CRM notifications.");
  //   }
  // };
  const fetchCRMNotifications = async () => {
    // if (!user || !user.admin_id || !user.superadmin_id) {
    //   console.warn(
    //     "Admin ID or SuperAdmin ID not available, skipping API call."
    //   );
    //   return;
    // }

    try {
      let res;
      const userRole = user?.role; // Assuming user role is stored in user.role

      // Check the user role and call the appropriate API
      if (userRole === "admin" && user?.admin_id) {
        res = await getAdminNotification(user.admin_id); // Get notifications for admin
      } else if (userRole === "superadmin" && user?.superadmin_id) {
        res = await getAdminNotification(user.superadmin_id); // Get notifications for superadmin
      } else {
        return; // Skip calling API if user role/ID is not ready
      }

      const formattedNotifications =
        res?.data?.notifications?.map((item, index) => ({
          message_content: item.message || "N/A",
        })) || [];

      setNotifications(formattedNotifications);
    } catch (err) {
      console.error("Error fetching CRM notifications:", err);
      setError("Failed to fetch CRM notifications.");
    }
  };

  // Fetch Student Messages and Map Sender ID with Student Data
  const fetchStudentMessages = async () => {
    try {
      const res = await getChatNotifications();

      const formattedMessages =
        res?.data?.map((item, index) => {
          // Find student based on sender id
          const student = students.find(
            (student) => student.student_id === item.sender
          );

          return {
            student_name: student ? student.username : "N/A",
            email_id: student ? student.email : "N/A",
            mobile_number: student ? student.phone_number : "N/A",
            // notification_text: item.notification || "N/A",
            message_content: item.content || "N/A",
          };
        }) || [];

      setMessages(formattedMessages);
    } catch (err) {
      console.error("Error fetching student messages:", err);
      setError("Failed to fetch student messages.");
    }
  };

  // Fetch data when user changes
  useEffect(() => {
    if (user) {
      const fetchData = async () => {
        await fetchCRMNotifications();
        await fetchStudentMessages();
        setLoading(false);
      };
      fetchData();
    }
  }, [user, students]); // ✅ Ensure useEffect runs when user or students updates

  return (
    <div className="p-6 min-h-screen">
      {loading ? (
        <p className="text-center text-gray-500">Loading data...</p>
      ) : error ? (
        <p className="text-center text-red-500">{error}</p>
      ) : (
        <>
          <NotificationTable title="CRM Notifications" data={notifications} />
          {user?.role !== "superadmin" && (
            <NotificationTable title="Student Messages" data={messages} />
          )}
        </>
      )}
    </div>
  );
};

export default NotificationsPage;
